var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.75V8.25M4.5 8.25V2.64629C4.5 2.42742 4.67742 2.25 4.89629 2.25H6.87868C8.23694 2.25 9.53957 2.78957 10.5 3.75C11.4604 4.71043 12.7631 5.25 14.1213 5.25H14.7358C14.8817 5.25 15 5.36828 15 5.51419V10.805C15 11.0508 14.8008 11.25 14.555 11.25H12.6213C11.2631 11.25 9.96043 10.7104 9 9.75C8.03957 8.78957 6.73694 8.25 5.37868 8.25H4.5Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTask);
export default __webpack_public_path__ + "static/media/IconTask.424003b23be219ae28d5c2742471f0ce.svg";
export { ForwardRef as ReactComponent };